export const WA_NUMBER = "6281280152007";
export const WA_DEFAULT_MSG =
  "Halo PT Raditya Konstruksi, saya ingin konsultasi pembangunan rumah mewah.";
export const waLink = (msg = WA_DEFAULT_MSG) =>
  `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(msg)}`;

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1756706718604-ef4af3970e33?crop=entropy&cs=srgb&fm=jpg&ixid=M3w8NTYxOTB8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBtb2Rlcm4lMjBhcmNoaXRlY3R1cmUlMjB2aWxsYSUyMGNvbmNyZXRlJTIwd29vZCUyMG1pbmltYWx8ZW58MHx8fHwxNzg5ODM1MDYwfDA&ixlib=rb-4.1.0&q=85",
  menteng: "https://images.unsplash.com/photo-1698994705178-d244d73ea573?crop=entropy&cs=srgb&fm=jpg&ixid=M3w8NTYxOTB8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBtb2Rlcm4lMjBhcmNoaXRlY3R1cmUlMjB2aWxsYSUyMGNvbmNyZXRlJTIwd29vZCUyMG1pbmltYWx8ZW58MHx8fHwxNzg5ODM1MDYwfDA&ixlib=rb-4.1.0&q=85",
  uluwatu: "https://images.pexels.com/photos/28586234/pexels-photo-28586234.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  pondokIndah: "https://images.pexels.com/photos/13041124/pexels-photo-13041124.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  bsd: "https://images.pexels.com/photos/28586227/pexels-photo-28586227.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  interior1: "https://images.unsplash.com/photo-1538431347070-1068ff5e62e6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBpbnRlcmlvciUyMGRlc2lnbiUyMGxpdmluZyUyMHJvb20lMjBtYW5zaW9uJTIwaW5kb25lc2lhfGVufDB8fHx8MTc4OTgzNTA2MHww&ixlib=rb-4.1.0&q=85",
  interior2: "https://images.pexels.com/photos/7031591/pexels-photo-7031591.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  interior3: "https://images.pexels.com/photos/6957083/pexels-photo-6957083.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const PROJECTS = [
  {
    id: "menteng-heritage",
    title: "Menteng Heritage Mansion",
    category: "Mansion",
    location: "Menteng, Jakarta Pusat",
    area: "1.850 m²",
    duration: "18 Bulan",
    year: "2024",
    image: IMAGES.menteng,
    description:
      "Restorasi penuh mansion kolonial menjadi hunian modern klasik — struktur beton bertulang baru di balik fasad heritage, dengan marmer Carrara dan joinery jati solid.",
  },
  {
    id: "uluwatu-cliff",
    title: "Uluwatu Cliff Residence",
    category: "Villa Tropis",
    location: "Uluwatu, Bali",
    area: "1.240 m²",
    duration: "14 Bulan",
    year: "2025",
    image: IMAGES.uluwatu,
    description:
      "Villa di tepi tebing dengan kantilever beton 7 meter menghadap Samudra Hindia. Kolam infinity tanpa batas dan atap tropis berlapis sirap ulin.",
  },
  {
    id: "pondok-indah-estate",
    title: "Pondok Indah Estate",
    category: "Mansion",
    location: "Pondok Indah, Jakarta Selatan",
    area: "2.100 m²",
    duration: "22 Bulan",
    year: "2023",
    image: IMAGES.pondokIndah,
    description:
      "Estate tiga lantai dengan basement galeri seni, lift privat, dan sistem smart-home terintegrasi. Fasad batu alam Andesit dipotong presisi CNC.",
  },
  {
    id: "bsd-sanctuary",
    title: "BSD Modern Sanctuary",
    category: "Modern Minimal",
    location: "BSD Grand, Tangerang Selatan",
    area: "780 m²",
    duration: "11 Bulan",
    year: "2025",
    image: IMAGES.bsd,
    description:
      "Hunian minimalis dengan beton ekspos arsitektural, courtyard hijau di jantung rumah, dan bukaan kaca floor-to-ceiling setinggi 4,2 meter.",
  },
  {
    id: "senayan-gallery",
    title: "Senayan Gallery House",
    category: "Modern Minimal",
    location: "Senayan, Jakarta",
    area: "950 m²",
    duration: "13 Bulan",
    year: "2024",
    image: IMAGES.interior1,
    description:
      "Rumah-galeri untuk kolektor seni: dinding museum-grade, pencahayaan track sistem Jerman, dan tangga baja sculptural sebagai pusat gravitasi ruang.",
  },
  {
    id: "canggu-tropical",
    title: "Canggu Tropical Villa",
    category: "Villa Tropis",
    location: "Canggu, Bali",
    area: "640 m²",
    duration: "10 Bulan",
    year: "2025",
    image: IMAGES.interior3,
    description:
      "Villa tropis kontemporer dengan lanskap hujan mikro, dinding batu Paras lokal, dan paviliun terbuka yang menyatu dengan sawah.",
  },
];

export const SERVICES = [
  {
    no: "01",
    title: "Desain & Bangun Baru",
    subtitle: "Full Villa & Mansion Build",
    description:
      "Dari lahan kosong hingga serah terima kunci. Tim arsitek, struktur, dan MEP in-house kami mewujudkan mansion dan villa mewah dengan presisi milimeter.",
    points: ["Struktur beton bertulang SNI", "Garansi struktur 10 tahun", "Laporan progres mingguan"],
  },
  {
    no: "02",
    title: "Renovasi Masterpiece",
    subtitle: "Luxury Renovation",
    description:
      "Transformasi total hunian existing menjadi karya arsitektur baru — tanpa kompromi pada kekuatan struktur lama.",
    points: ["Audit struktur menyeluruh", "Perkuatan fondasi & kolom", "Finishing premium impor"],
  },
  {
    no: "03",
    title: "Interior & Custom Joinery",
    subtitle: "Bespoke Interior Works",
    description:
      "Joinery kayu solid buatan tangan, dapur Italia, walk-in closet, dan pencahayaan arsitektural yang dikurasi per ruang.",
    points: ["Workshop kayu sendiri", "Material jati & walnut grade-A", "Detail hardware Eropa"],
  },
  {
    no: "04",
    title: "Advisory Arsitektural & Struktural",
    subtitle: "Architectural & Structural Advisory",
    description:
      "Konsultasi kelayakan lahan, audit desain arsitek pihak ketiga, dan value engineering untuk mengoptimalkan biaya tanpa menurunkan mutu.",
    points: ["Due diligence lahan", "Review gambar kerja", "Estimasi RAB transparan"],
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "Raditya menyelesaikan mansion kami 3 minggu lebih cepat dari jadwal — dengan kerapian finishing yang belum pernah saya lihat di kontraktor lain.",
    name: "Bpk. Hendra Wijaya",
    role: "Pemilik Menteng Heritage Mansion",
  },
  {
    quote:
      "Setiap detail diperdebatkan dan disempurnakan. Kantilever villa kami di Uluwatu adalah bukti bahwa mereka insinyur sekaligus seniman.",
    name: "Bpk. Made Ariana",
    role: "Pemilik Uluwatu Cliff Residence",
  },
  {
    quote:
      "Laporan progres mingguan dengan foto drone membuat kami tenang meski berada di luar negeri selama pembangunan.",
    name: "Ibu Larasati Prameswari",
    role: "Pemilik Pondok Indah Estate",
  },
];

export const MARQUEE_ITEMS = [
  "INTEGRITAS STRUKTURAL",
  "CRAFTSMANSHIP TANPA KOMPROMI",
  "RUMAH MEWAH INDONESIA",
  "BETON BERTULANG BESPOKE",
  "PRESISI ARSITEKTUR",
  "GARANSI STRUKTUR 10 TAHUN",
];
